import React from 'react';
import { ISegmentScrollChildrenWrapperProps } from './type';

export const SegmentScrollChildrenWrapper = (
  props: ISegmentScrollChildrenWrapperProps,
) => {
  const { className, style, id, refArray, index, children, ...restProps } = props;

  return (
    <div ref={refArray?.[index]} id={id} className={className} style={style}>
      {React.Children.map(children, (child) => React.cloneElement(child, restProps))}
    </div>
  );
};
